import RestPaginationService from '../rest-pagination-service'

class AdminNotificationService extends RestPaginationService {
  constructor() {
    super('/api/admin/generalNotification')
  }
}

export default AdminNotificationService
